// this will return a map of language to default locale
// for example: { en: 'en-US', fr: 'fr-FR' }
function getLanguageToDefaultLocaleMap(supportedLocales: Set<string>) {
  const languageToDefaultLocaleMap = new Map<string, string>();

  supportedLocales.forEach((locale) => {
    const language = locale.split('-')[0];

    if (!languageToDefaultLocaleMap.has(language)) {
      languageToDefaultLocaleMap.set(language, locale);
    }
  });

  return languageToDefaultLocaleMap;
}

export function getLocaleBasedOnLanguage(locale: string, supportedLocalesSet: Set<string>) {
  const languageToDefaultLocaleMap = getLanguageToDefaultLocaleMap(supportedLocalesSet);
  const language = locale.split('-')[0];
  return languageToDefaultLocaleMap.get(language);
}
